import type {
  VehicleResultsTableProps,
  VehicleTableData
} from "@dealer-center/ddc-pages-inventory-archiver-interface";
import { StyledTableWrapper, TableStyles } from "./ResultsTablesStyles";
import { Table } from "@dealer-center/core-components";
import ResultsTableHeader from "./ResultsTableHeader";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const TABLE_SCROLL_X = 1475;
const TABLE_SCROLL_Y = 1000;

export const DataTable = (props: VehicleResultsTableProps) => {
  const [params] = useSearchParams();

  const filteredRows = useMemo(() => {
    const filters: Record<string, string> = {};
    params.forEach((value, key) => {
      if (key !== "accountId") filters[key] = value;
    });

    return props.rows.filter(item =>
      Object.keys(filters).every(key => {
        if (!(key in item)) return true;
        const cellValue = item[key as keyof VehicleTableData];
        if (!Array.isArray(cellValue)) return false;
        return cellValue.some(v => v.includes(filters[key]));
      })
    );
  }, [params, props.rows]);

  return (
    <StyledTableWrapper>
      {props.headerData.length > 0 && (
        <ResultsTableHeader
          checkedCategories={props.checkedCategories}
          data={props.headerData}
          onToggleHeaders={props.onToggleHeaders}
        />
      )}
      <Table.Table
        displayFilter
        displayPageSizeSelector
        highlightOnHover
        sortableColumns
        columns={props.columns}
        currentPageSize={100}
        data={filteredRows}
        dataDensity="small"
        emptyText={props.emptyText || "No data found"}
        scrollX={TABLE_SCROLL_X}
        scrollY={TABLE_SCROLL_Y}
        tableLayout="auto"
      />
      <TableStyles />
    </StyledTableWrapper>
  );
};
